import * as Sentry from "@sentry/react";

const API_BASE = import.meta.env.VITE_API_URL || 'https://api.careersorter.co';
const API_URL = `${API_BASE}/v1`;

export async function apiGet(path, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const url = `${API_URL}${path}`;
  const res = await fetch(url, { headers });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const error = new Error(`API ${res.status}: ${text}`);
    error.status = res.status;
    if (res.status !== 402) {
      Sentry.captureException(error, { extra: { url, status: res.status } });
    }
    throw error;
  }
  return res.json();
}

export async function apiPost(path, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const url = `${API_URL}${path}`;
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const error = new Error(`API ${res.status}: ${text}`);
    error.status = res.status;
    if (res.status !== 402) {
      Sentry.captureException(error, { extra: { url, status: res.status } });
    }
    throw error;
  }
  return res.json();
}

export async function apiPatch(path, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const url = `${API_URL}${path}`;
  const res = await fetch(url, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const error = new Error(`API ${res.status}: ${text}`);
    error.status = res.status;
    if (res.status !== 402) {
      Sentry.captureException(error, { extra: { url, status: res.status } });
    }
    throw error;
  }
  return res.json();
}

export async function apiDelete(path, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const url = `${API_URL}${path}`;
  const res = await fetch(url, {
    method: 'DELETE',
    headers,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const error = new Error(`API ${res.status}: ${text}`);
    error.status = res.status;
    if (res.status !== 402) {
      Sentry.captureException(error, { extra: { url, status: res.status } });
    }
    throw error;
  }
  return res.json();
}
